(function () {
  var NUMERIC_VALUE = /^\d+(\.\d+)?([\/\-].*)?$/;

  function sortKey(value) {
    var parts = value.split('/');
    var primary = parseFloat(parts[0]);
    var secondary = parts.length > 1 ? parseFloat(parts[1]) : 0;
    return {
      primary: isNaN(primary) ? 0 : primary,
      secondary: isNaN(secondary) ? 0 : secondary,
      raw: value,
    };
  }

  function sortPillList(list) {
    var items = Array.prototype.slice.call(list.querySelectorAll(':scope > li[data-value]'));
    if (items.length < 2) return;

    var allNumeric = items.every(function (li) {
      return NUMERIC_VALUE.test(li.getAttribute('data-value'));
    });
    if (!allNumeric) return;

    var sorted = items.slice().sort(function (a, b) {
      var ka = sortKey(a.getAttribute('data-value'));
      var kb = sortKey(b.getAttribute('data-value'));
      if (ka.primary !== kb.primary) return ka.primary - kb.primary;
      if (ka.secondary !== kb.secondary) return ka.secondary - kb.secondary;
      return ka.raw < kb.raw ? -1 : ka.raw > kb.raw ? 1 : 0;
    });

    var changed = sorted.some(function (li, index) {
      return li !== items[index];
    });
    if (!changed) return;

    sorted.forEach(function (li) {
      list.appendChild(li);
    });
  }

  function sortAllSwatchLists() {
    document
      .querySelectorAll('.globo-swatch-product-detail .swatch--gl ul.value')
      .forEach(sortPillList);
  }

  function init() {
    var container = document.querySelector('.globo-swatch-product-detail');
    if (!container) return;

    if (container.querySelector('ul.value li[data-value]')) {
      sortAllSwatchLists();
      return;
    }

    var observer = new MutationObserver(function () {
      if (container.querySelector('ul.value li[data-value]')) {
        observer.disconnect();
        sortAllSwatchLists();
      }
    });
    observer.observe(container, { childList: true, subtree: true });
    setTimeout(function () {
      observer.disconnect();
    }, 15000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
